import { render } from "./vresourcesglobal.vue?vue&type=template&id=2855390b&scoped=true"
import script from "./vresourcesglobal.vue?vue&type=script&lang=js"
export * from "./vresourcesglobal.vue?vue&type=script&lang=js"

import "./vresourcesglobal.vue?vue&type=style&index=0&id=2855390b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2855390b"]])

export default __exports__